import React from 'react';
import QuestionRenderer from './QuestionRenderer';

const QuestionList = ({ questions, answerOptions, answers, onAnswerChange, questionOffset = 0 }) => (
  <>
    {questions.map((question, qIndex) => {
      // Determine the correct answerOptions array for this question
      let options = answerOptions;
      if (
        answerOptions &&
        typeof answerOptions === 'object' &&
        !Array.isArray(answerOptions) &&
        question.answerOptions
      ) {
        options = answerOptions[question.answerOptions] || [];
      }
      return (
        <QuestionRenderer
          key={qIndex}
          question={question}
          questionNumber={qIndex + 1 + questionOffset}
          answerOptions={options}
          onAnswerChange={
            onAnswerChange === null ? null :
            (value, itemIndex) => onAnswerChange(qIndex, value, itemIndex)
          }
          answer={answers[qIndex]}
        />
      );
    })}
  </>
);

export default QuestionList;